export { HeroGallery } from './HeroGallery';
export type { HeroGalleryProps } from './HeroGallery.types';
